import { GameType } from 'types/types'

export const SELECTION_KEYS_FOR_STATS = {
  [GameType.SR]: 'SCORE',
  [GameType.WDW]: 'RESULT',
  [GameType.MARGIN]: 'MARGIN_SCORE',
  [GameType.LMS]: 'LMS',
  [GameType.PTW]: 'PTW',
  [GameType.DRAFT]: 'DRAFT',
  [GameType.ODDS]: 'ODDS',
} as const

export const GameStatus = {
  UPCOMING: 'UPCOMING',
  ACTIVE: 'ACTIVE',
  FINISHED: 'FINISHED',
  READY_FOR_SETTLE: 'READY_FOR_SETTLE',
  CANCELLED: 'CANCELLED',
} as const

export const PASSWORD_ERROR_MESSAGES = {
  TOO_SHORT: 'Password must be at least 8 characters long',
  NUMBER: 'Password must contain at least one number',
  ONE_UPPERCASE_AND_LOWER: 'Password must contain at least one uppercase and one lowercase letter',
  NO_MATCH: 'Passwords do not match',
} as const

export const FORM_GATES = {
  FORM: 'FORM',
  SAVE_PREDICTIONS: 'SAVE_PREDICTIONS',
  REGISTER: 'REGISTER',
  JOIN_MINI_LEAGUE_PIN: 'JOIN_MINI_LEAGUE_PIN',
  CREATE_MINI_LEAGUE: 'CREATE_MINI_LEAGUE',
  LEADERBOARD_GAME_FINISHED: 'LEADERBOARD_GAME_FINISHED',
}

export const FlowTypes = {
  AUTH: 'auth',
  JOIN: 'join',
} as const

export const STEPS = {
  PRIVATE_LEAGUES: 'Private Leagues',
  ACCOUNT: 'Account',
  CHARITY: 'Donate',
  FORM: 'Survey',
} as const

export const ADDITIONAL_QUESTION_PLACE = {
  JOIN_GAME: 'join game',
  SIGN_UP: 'sign up',
}

export const PRIZE_DRAW_SESSION_KEY = 'prizeDrawPurchaseData'
